import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Button, ButtonMode, Loader } from '@creditsights/styleguide-web';
import { NavLink } from 'react-router-dom';
import styles from './ContextMenuItem.module.scss';

const cx = classNames.bind(styles);

interface ContextMenuItemProps {
  icon?: ReactElement;
  isLoading?: boolean;
  title: string;
  action?: () => void;
  linkTo?: string;
  small?: boolean;
}

const ContextMenuItem = (props: ContextMenuItemProps): React.ReactElement => {
  const { icon, isLoading, title, action, linkTo, small = false } = props;
  if (linkTo) {
    return (
      <div className={cx('body', { small })}>
        <NavLink className={cx('link')} to={linkTo}>
          {title}
        </NavLink>
      </div>
    );
  }

  return (
    <Button
      className={cx('body')}
      mode={ButtonMode.PLAIN}
      onClick={action}
      onMouseUp={(e) => e.stopPropagation()}
      disabled={isLoading}
    >
      {isLoading && <Loader color="primary" text={null} />}
      {!isLoading && icon}
      <span className={cx('title')}>{title}</span>
    </Button>
  );
};

export default ContextMenuItem;
